import type { SelectConfig } from '@common';
import { FormDefaultAttributes } from '@common';

export const DECISION_SUPPORT_WIZARD_PARCEL_FORM_CONFIG = {
  name: 'decisionSupportWizardParcelForm',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      name: 'upkeepCost',
      component: 'text',
      attributes: {
        type: 'number',
        label: 'decisionSupport.wizard.label.upkeepCost',
        suffix: 'Ft/ha',
        persistentHint: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 6
        },
        mask: {
          mask: /^[1-9]\d*/
        }
      },
      filters: [
        {
          filter: 'integer',
          settings: {
            min: 0
          }
        }
      ],
      validators: [
        {
          validator: 'required'
        }
      ],
      plugins: [
        {
          plugin: 'upkeepCostHintChange'
        }
      ]
    },
    {
      name: 'cropPrice',
      component: 'text',
      attributes: {
        type: 'number',
        label: 'decisionSupport.wizard.label.cropPrice',
        suffix: 'Ft/t'
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 6
        },
        mask: {
          mask: /^[1-9]\d*/
        }
      },
      filters: [
        {
          filter: 'integer',
          settings: {
            min: 0
          }
        }
      ],
      validators: [
        {
          validator: 'required'
        }
      ]
    },
    {
      name: 'source',
      component: 'select',
      attributes: {
        label: 'decisionSupport.wizard.label.source',
        itemTitle: 'name',
        itemValue: 'value',
        returnObject: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 12
        }
      },
      validators: [
        {
          validator: 'required'
        }
      ]
    } as SelectConfig
  ]
};
